/**
 * Function that does nothing. But we can avoid some null/undefined checks.
 * A constant is used to avoid allocation overhead at runtime.
 */
export const noop = () => {
    // do nothing => noop => no op => no operation
};
//# sourceMappingURL=noop.js.map